module.exports = __webpack_public_path__ + "static/media/no_medias.1a617830.png";